// extracted by mini-css-extract-plugin
export default {"addBtnTaxt":"AddButton_addBtnTaxt__fK4Jk","addBtn":"AddButton_addBtn__yHQ0F"};